import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-rep-contabilidad',
  templateUrl: './rep-contabilidad.component.html',
  styleUrls: ['./rep-contabilidad.component.scss']
})
export class RepContabilidadComponent{

  constructor(private loginService: LoginService) { }

  clickGuard() {
    this.loginService.clickGuard = true;
  }

}
